/**
 * Forma del esqueleto de carga de un widget.
 *
 * Vive aparte del componente que la pinta porque el kit exige que un módulo con
 * componentes sólo exporte componentes (`react-refresh/only-export-components`):
 * mezclar el mapa con el JSX rompe el hot reload.
 */

export type SkeletonShape = 'kpi' | 'line' | 'bars' | 'donut' | 'table' | 'image' | 'generic';

/** Mapa tipo de widget → forma del esqueleto. */
const SHAPE_BY_TYPE: Record<string, SkeletonShape> = {
  kpi: 'kpi',
  chart_line: 'line',
  chart_bar_vertical: 'bars',
  chart_bar_horizontal: 'bars',
  chart_donut: 'donut',
  table: 'table',
  image: 'image',
};

/** La forma que corresponde a un `WidgetDefinition.tipo`. Los desconocidos caen en `generic`. */
export function skeletonShapeFor(tipo: string | undefined): SkeletonShape {
  return (tipo && SHAPE_BY_TYPE[tipo]) || 'generic';
}
